import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixelTracker() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) return; // already initialized
    try {
      // Official Facebook Pixel base code, ported from Meta's snippet
      ;
      (function (f: any, b: Document, e: string, v: string) {
        let n: any;
        if (f.fbq) return;
        n = f.fbq = function () {
          // eslint-disable-next-line prefer-rest-params
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        // Silently swallow any load/network errors from the third-party script
        t.onerror = () => {
          /* noop — pixel script blocked or failed to load */
        };
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      try {
        window.fbq('init', PIXEL_ID);
        window.fbq('track', 'PageView');
      } catch {
        /* fbq not yet available or blocked */
      }
    } catch {
      /* swallow any pixel install error in restricted environments */
    }
    // Capture global errors that originate from the cross-origin pixel script
    // so they don't surface as "Script error." in the preview overlay.
    const handler = (event: ErrorEvent) => {
      const src = (event.filename || '') + ' ' + (event.message || '');
      if (src.includes('fbevents') || src.includes('facebook.net') || src.includes('facebook.com')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    window.addEventListener('error', handler, true);
    return () => {
      window.removeEventListener('error', handler, true);
    };
  }, []);
  return null;
}